



































import { Component, Vue, Prop } from 'vue-property-decorator'
import { NightVoteResult, Vote } from '@/class/game'
import Player from './Player.vue'
import Card from '@/components/Common/Card/Card.vue'

@Component({
  components: {
    Player,
    Card
  }
})
export default class ReplayNightVoteViewer extends Vue {
  @Prop() nightVoteResult!: NightVoteResult;

  get votedDataList () {
    return this.makeVotedDataList(this.votedData)
  }

  get abandonPlayers () {
    return this.votedData.abandon
  }

  makeVotedDataList (voteData: Vote) {
    const voted: {targetPlayerId: string; votedPlayerIds: string[]}[] = []
    Object.keys(voteData.vote).forEach((key) => {
      voted.push({ targetPlayerId: key, votedPlayerIds: voteData.vote[key] })
    })
    return voted.sort((a, b) => b.votedPlayerIds.length - a.votedPlayerIds.length)
  }

  get votedData () {
    return this.nightVoteResult.nightVotedData
  }

  getPlayer (playerId: string) {
    return this.nightVoteResult.players[playerId]
  }
}
